import { AppColors } from "@/styles/colors";
import { Box, Grid, GridItem, Text } from "@chakra-ui/react";
import { SelectedDays } from "../schema/logistic.schema";
import { DayCell } from "./DayCell";
import { RefObject } from "react";
import dayjs from "dayjs";

interface Props {
  monthName: string;
  monthIndex: number;
  cells: (number | null)[];
  selectedValues: SelectedDays;
  currentBlockedDates: Set<string>;
  initialReasonsRef: RefObject<Map<string, string>>;
  toggleBlockedDate: (dateKey: string) => void;
  canToggle: boolean;
}

export const MonthGridItem = ({
  monthName,
  monthIndex,
  cells,
  selectedValues,
  currentBlockedDates,
  initialReasonsRef,
  toggleBlockedDate,
  canToggle,
}: Props) => {
  const pad2 = (n: number) => String(n).padStart(2, "0");
  const buildDateKey = (year: number, month0: number, day: number) => {
    return `${year}-${pad2(month0 + 1)}-${pad2(day)}`;
  };

  return (
    <GridItem
      key={monthName}
      borderRadius="12px"
      border={`1px solid ${AppColors.WHITE_BORDER_1}`}
      padding="12px"
    >
      <Text fontWeight={700} textAlign="center" marginBottom="8px">
        {monthName}
      </Text>

      <Grid templateColumns="repeat(7, 1fr)" gap="6px">
        {cells.map((day, idx) => {
          if (!day) {
            return (
              <Box key={`${monthName}-b-${idx}`} height="22px" width="100%" />
            );
          }

          const dateKey = buildDateKey(selectedValues.year, monthIndex, day);
          const isBlocked = currentBlockedDates.has(dateKey);

          return (
            <DayCell
              key={`${monthName}-${day}`}
              year={selectedValues.year}
              monthIndex={monthIndex}
              day={day}
              isBlocked={isBlocked}
              reasonsMap={initialReasonsRef.current}
              onToggle={toggleBlockedDate}
              canToggle={canToggle}
              disabled={dayjs(dateKey).isBefore(dayjs())}
            />
          );
        })}
      </Grid>
    </GridItem>
  );
};
